"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("@/helpers");
var _underLoading = require("../helpers/under-loading");
var _mutationTypes = require("../mutation-types");
var _monitorService = _interopRequireDefault(require("@/services/monitor.service.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getInitialState = function getInitialState() {
  return {
    typeMonitor: {},
    listMonitor: []
  };
};
var state = getInitialState();
var mutations = _defineProperty(_defineProperty(_defineProperty({}, _mutationTypes.SET_SERVICES_MONITOR_PER_TYPE, function (mutationState, payload) {
  mutationState.typeMonitor = payload;
}), _mutationTypes.SET_SERVICES_MONITOR_LIST, function (mutationState, payload) {
  mutationState.listMonitor = payload;
}), _mutationTypes.RESET_MONITOR_STATE, function (mutationState) {
  Object.assign(mutationState, getInitialState());
});
var getters = {
  getListServicePerType: function getListServicePerType(state) {
    return state.typeMonitor;
  },
  listMonitor: function listMonitor(state) {
    return state.listMonitor;
  }
};
var actions = {
  fetchListMonitor: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref, payload) {
      var commit, _yield$MonitorService, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref.commit;
            _context.p = 1;
            _context.n = 2;
            return _monitorService.default.fetchListMonitor(payload);
          case 2:
            _yield$MonitorService = _context.v;
            data = _yield$MonitorService.data;
            commit(_mutationTypes.SET_SERVICES_MONITOR_LIST, data);
            return _context.a(2, data);
          case 3:
            _context.p = 3;
            _t = _context.v;
            _helpers.errorResponseHelper.display(_t);
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()),
  fetchCountRequestPerType: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref3, payload) {
      var commit, _yield$MonitorService2, data, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref3.commit;
            _context2.p = 1;
            _context2.n = 2;
            return _monitorService.default.fetchCountRequestPerType(payload);
          case 2:
            _yield$MonitorService2 = _context2.v;
            data = _yield$MonitorService2.data;
            commit(_mutationTypes.SET_COUNT_REQUEST_PER_TYPE, data);
            return _context2.a(2, data);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            _helpers.errorResponseHelper.display(_t2);
            return _context2.a(2, false);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function (_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }()),
  fetchLatestCallServiceActiveChartReception: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref5, payload) {
      var commit, _yield$MonitorService3, data, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref5.commit;
            _context3.p = 1;
            _context3.n = 2;
            return _monitorService.default.fetchLatestCallServiceActiveChartReception(payload);
          case 2:
            _yield$MonitorService3 = _context3.v;
            data = _yield$MonitorService3.data;
            return _context3.a(2, data);
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }()),
  fetchServicesLatestRequestPerType: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref7, payload) {
      var commit, _yield$MonitorService4, data, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref7.commit;
            _context4.p = 1;
            _context4.n = 2;
            return _monitorService.default.fetchServicesLatestRequestPerType(payload);
          case 2:
            _yield$MonitorService4 = _context4.v;
            data = _yield$MonitorService4.data;
            return _context4.a(2, data);
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            _helpers.errorResponseHelper.display(_t4);
            return _context4.a(2, false);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return function (_x7, _x8) {
      return _ref8.apply(this, arguments);
    };
  }()),
  fetchServicesSuccessAndErrors: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref9, payload) {
      var commit, _yield$MonitorService5, data, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref9.commit;
            _context5.p = 1;
            _context5.n = 2;
            return _monitorService.default.fetchServicesSuccessAndErrors(payload);
          case 2:
            _yield$MonitorService5 = _context5.v;
            data = _yield$MonitorService5.data;
            return _context5.a(2, data);
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            _helpers.errorResponseHelper.display(_t5);
            return _context5.a(2, false);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x9, _x0) {
      return _ref0.apply(this, arguments);
    };
  }()),
  fetchServicesStatusRequestChart: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref1, payload) {
      var commit, _yield$MonitorService6, data, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref1.commit;
            _context6.p = 1;
            _context6.n = 2;
            return _monitorService.default.fetchServicesStatusRequestChart(payload);
          case 2:
            _yield$MonitorService6 = _context6.v;
            data = _yield$MonitorService6.data;
            return _context6.a(2, data);
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            _helpers.errorResponseHelper.display(_t6);
            return _context6.a(2, false);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x1, _x10) {
      return _ref10.apply(this, arguments);
    };
  }()),
  fetchServiceRequestErrorsList: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref11, payload) {
      var commit, _yield$MonitorService7, data, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref11.commit;
            _context7.p = 1;
            _context7.n = 2;
            return _monitorService.default.fetchServiceRequestErrorsList(payload);
          case 2:
            _yield$MonitorService7 = _context7.v;
            data = _yield$MonitorService7.data;
            return _context7.a(2, data);
          case 3:
            _context7.p = 3;
            _t7 = _context7.v;
            _helpers.errorResponseHelper.display(_t7);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function (_x11, _x12) {
      return _ref12.apply(this, arguments);
    };
  }()),
  fetchTotalRequestByService: function () {
    var _fetchTotalRequestByService = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref13, _ref14) {
      var commit, id, params, _yield$MonitorService8, data, _t8;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            commit = _ref13.commit;
            id = _ref14.id, params = _ref14.params;
            _context8.p = 1;
            _context8.n = 2;
            return _monitorService.default.fetchTotalRequestByService(id, params);
          case 2:
            _yield$MonitorService8 = _context8.v;
            data = _yield$MonitorService8.data;
            return _context8.a(2, data);
          case 3:
            _context8.p = 3;
            _t8 = _context8.v;
            _helpers.errorResponseHelper.display(_t8);
            return _context8.a(2, false);
        }
      }, _callee8, null, [[1, 3]]);
    }));
    function fetchTotalRequestByService(_x13, _x14) {
      return _fetchTotalRequestByService.apply(this, arguments);
    }
    return fetchTotalRequestByService;
  }(),
  fetchChartRequestCreatedHive: function () {
    var _fetchChartRequestCreatedHive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref15, _ref16) {
      var commit, id, params, _yield$MonitorService9, data, _t9;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            commit = _ref15.commit;
            id = _ref16.id, params = _ref16.params;
            _context9.p = 1;
            _context9.n = 2;
            return _monitorService.default.fetchChartRequestCreatedHive(id, params);
          case 2:
            _yield$MonitorService9 = _context9.v;
            data = _yield$MonitorService9.data;
            return _context9.a(2, data);
          case 3:
            _context9.p = 3;
            _t9 = _context9.v;
            _helpers.errorResponseHelper.display(_t9);
            return _context9.a(2, false);
        }
      }, _callee9, null, [[1, 3]]);
    }));
    function fetchChartRequestCreatedHive(_x15, _x16) {
      return _fetchChartRequestCreatedHive.apply(this, arguments);
    }
    return fetchChartRequestCreatedHive;
  }(),
  fetchChartRequestCreatedProvider: function () {
    var _fetchChartRequestCreatedProvider = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(_ref17, _ref18) {
      var commit, id, params, _yield$MonitorService0, data, _t0;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            commit = _ref17.commit;
            id = _ref18.id, params = _ref18.params;
            _context0.p = 1;
            _context0.n = 2;
            return _monitorService.default.fetchChartRequestCreatedProvider(id, params);
          case 2:
            _yield$MonitorService0 = _context0.v;
            data = _yield$MonitorService0.data;
            return _context0.a(2, data);
          case 3:
            _context0.p = 3;
            _t0 = _context0.v;
            _helpers.errorResponseHelper.display(_t0);
            return _context0.a(2, false);
        }
      }, _callee0, null, [[1, 3]]);
    }));
    function fetchChartRequestCreatedProvider(_x17, _x18) {
      return _fetchChartRequestCreatedProvider.apply(this, arguments);
    }
    return fetchChartRequestCreatedProvider;
  }(),
  fetchChartRequestReceivedHive: function () {
    var _fetchChartRequestReceivedHive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(_ref19, _ref20) {
      var commit, id, params, _yield$MonitorService1, data, _t1;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            commit = _ref19.commit;
            id = _ref20.id, params = _ref20.params;
            _context1.p = 1;
            _context1.n = 2;
            return _monitorService.default.fetchChartRequestReceivedHive(id, params);
          case 2:
            _yield$MonitorService1 = _context1.v;
            data = _yield$MonitorService1.data;
            return _context1.a(2, data);
          case 3:
            _context1.p = 3;
            _t1 = _context1.v;
            _helpers.errorResponseHelper.display(_t1);
            return _context1.a(2, false);
        }
      }, _callee1, null, [[1, 3]]);
    }));
    function fetchChartRequestReceivedHive(_x19, _x20) {
      return _fetchChartRequestReceivedHive.apply(this, arguments);
    }
    return fetchChartRequestReceivedHive;
  }(),
  fetchChartRequestSendClient: function () {
    var _fetchChartRequestSendClient = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(_ref21, _ref22) {
      var commit, id, params, _yield$MonitorService10, data, _t10;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.p = _context10.n) {
          case 0:
            commit = _ref21.commit;
            id = _ref22.id, params = _ref22.params;
            _context10.p = 1;
            _context10.n = 2;
            return _monitorService.default.fetchChartRequestSendClient(id, params);
          case 2:
            _yield$MonitorService10 = _context10.v;
            data = _yield$MonitorService10.data;
            return _context10.a(2, data);
          case 3:
            _context10.p = 3;
            _t10 = _context10.v;
            _helpers.errorResponseHelper.display(_t10);
            return _context10.a(2, false);
        }
      }, _callee10, null, [[1, 3]]);
    }));
    function fetchChartRequestSendClient(_x21, _x22) {
      return _fetchChartRequestSendClient.apply(this, arguments);
    }
    return fetchChartRequestSendClient;
  }(),
  fetchLatestRequestStepByService: function () {
    var _fetchLatestRequestStepByService = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(_ref23, _ref24) {
      var commit, id, params, _yield$MonitorService11, data, _t11;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.p = _context11.n) {
          case 0:
            commit = _ref23.commit;
            id = _ref24.id, params = _ref24.params;
            _context11.p = 1;
            _context11.n = 2;
            return _monitorService.default.fetchLatestRequestStepByService(id, params);
          case 2:
            _yield$MonitorService11 = _context11.v;
            data = _yield$MonitorService11.data;
            return _context11.a(2, data);
          case 3:
            _context11.p = 3;
            _t11 = _context11.v;
            _helpers.errorResponseHelper.display(_t11);
            return _context11.a(2, false);
        }
      }, _callee11, null, [[1, 3]]);
    }));
    function fetchLatestRequestStepByService(_x23, _x24) {
      return _fetchLatestRequestStepByService.apply(this, arguments);
    }
    return fetchLatestRequestStepByService;
  }(),
  fetchMonitorRequestsTimeIntervals: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref26 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(_ref25, payload) {
      var commit, _yield$MonitorService12, data, _t12;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.p = _context12.n) {
          case 0:
            commit = _ref25.commit;
            _context12.p = 1;
            _context12.n = 2;
            return _monitorService.default.fetchRequestsTimeIntervals(payload.id, payload.startDate, payload.endDate);
          case 2:
            _yield$MonitorService12 = _context12.v;
            data = _yield$MonitorService12.data;
            return _context12.a(2, data);
          case 3:
            _context12.p = 3;
            _t12 = _context12.v;
            _helpers.errorResponseHelper.display(_t12);
            return _context12.a(2, false);
        }
      }, _callee12, null, [[1, 3]]);
    }));
    return function (_x25, _x26) {
      return _ref26.apply(this, arguments);
    };
  }()),
  fetchChartRequestTime: function () {
    var _fetchChartRequestTime = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(_ref27, _ref28) {
      var commit, id, params, _yield$MonitorService13, data, _t13;
      return _regenerator().w(function (_context13) {
        while (1) switch (_context13.p = _context13.n) {
          case 0:
            commit = _ref27.commit;
            id = _ref28.id, params = _ref28.params;
            _context13.p = 1;
            _context13.n = 2;
            return _monitorService.default.fetchChartRequestTime(id, params);
          case 2:
            _yield$MonitorService13 = _context13.v;
            data = _yield$MonitorService13.data;
            return _context13.a(2, data);
          case 3:
            _context13.p = 3;
            _t13 = _context13.v;
            _helpers.errorResponseHelper.display(_t13);
            return _context13.a(2, false);
        }
      }, _callee13, null, [[1, 3]]);
    }));
    function fetchChartRequestTime(_x27, _x28) {
      return _fetchChartRequestTime.apply(this, arguments);
    }
    return fetchChartRequestTime;
  }()
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};